module.exports = __webpack_public_path__ + "static/media/servdrop-icon-only.f99bbd84.png";